<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="stowage.status === 'recorded'"
          v-can="'stowage.update'"
          :command="close"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Termékek kiadása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stowage.status === 'recorded'"
          v-can="'stowage.update'"
          :command="updateStowage"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'stowage.view'"
          v-if="stowage.receipt_file_url"
          :command="openReceipt"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Bizonylat nyomtatása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stowage.status === 'recorded'"
          v-can="'stowage.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: ['stowage'],
  data() {
    return {
      buttonLoader: false,
      deleteConfirmVisible: false,
    };
  },

  methods: {
    async deleteStowage() {
      this.buttonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('stowage/delete', this.stowage.id);
        this.$store.dispatch('stowage/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async updateStowage() {
      this.$router.push('/sales/stowages/update/' + this.stowage.id);
    },
    async close() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('stowage/close', this.stowage.id);
        this.$store.dispatch('stowage/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async openReceipt() {
      if (this.stowage.receipt_file_url) {
        this.buttonLoader = true;
        try {
          const url = await axios.get('api/files?path=' + this.stowage.receipt_file_url);
          window.open(url);
        } catch (e) {
        }
        this.buttonLoader = false;
      }
    },
    openDeleteConfirmation() {
      this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
        confirmButtonText: 'Igen',
        cancelButtonText: 'Mégse',
        type: 'warning',
      })
      .then(() => {
        this.deleteStowage();
      })
      .catch(() => {
        this.$router.replace('/sales/stowages');
      });
    },
    handleAction(action) {
      action();
    },
    toggleDropDown() {
      this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
    },
    async exportExcel() {
      try {
        this.buttonLoader = true;
        const excel = await axios({
          url: 'api/stowages/' + this.stowage.id + '/export',
          method: 'GET',
          responseType: 'blob',
        });
        saveAs(excel, 'stowage_items.xlsx');
      } catch (e) {
      }
      this.buttonLoader = false;

    },
  }
};
</script>
